module.exports = __webpack_public_path__ + "img/sphere02-graph-black.f197617c.png";